module.exports = __webpack_public_path__ + "static/media/logo-w.7bc27c6b.png";